const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.CLIENT_DIETS)
const groupPrefixDays = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.BOX_PACKAGINGS)

export const apiOrderClient = {
	fetchOrderDayCancelCalculation: async (day: string | string[]) => {
		const days = Array.isArray(day) ? day : [day]
		const { data } = await apiCommon<IOrderClientDayCancelCalculation>(
			`${groupPrefix}/cancel-diet-days/calculate`,
			{
				method: 'POST',
				body: {
					client_diet_days: days,
				},
			},
		)

		return OrderClientDayCancelCalculation(data)
	},
	cancelOrderDay: async (payload: IOrderClientDayCancelPayload): Promise<void> => {
		await apiCommon<IOrderDay[]>(`${groupPrefix}/cancel-diet-days`, {
			method: 'POST',
			body: payload,
		})
	},

	fetchClientPackages: async (
		page: number = 1,
		perPage: number = 25,
		search?: string,
		filters?: IClientPackageFilters,
		sorting?: ISortingOption,
	): Promise<{ data: IClientPackageModel[]; meta: IApiMetaModel | undefined }> => {
		const { data, meta } = await apiCommon<IClientPackage[]>(`${groupPrefixDays}`, {
			method: 'GET',
			...createQuery(
				{ page, perPage },
				{
					search,
					id: filters?.id,
					'clientDiet.status': filters?.clientDietStatus,
					status: filters?.status,
					date_from: filters?.dateFrom,
					date_to: filters?.dateTo,
					diet_group: filters?.dietGroup,
				},
				sorting ? { [sorting.key]: sorting.type } : undefined,
			),
		})

		return { data: clientPackagesModel(data), meta }
	},

	searchBoxPackaging: async (
		id: string,
		page: number = 1,
		perPage: number = 25,
	): Promise<{ data: IClientPackageModel[]; meta: IApiMetaModel | undefined }> => {
		const { data, meta } = await apiCommon<IClientPackage[]>(`${groupPrefixDays}/search`, {
			method: 'GET',
			...createQuery({ page, perPage }, { id }),
		})

		return { data: clientPackagesModel(data), meta }
	},

	fetchBoxDetails: async (boxID: number): Promise<IClientPackageDetailsModel> => {
		const { data } = await apiCommon<IClientPackageDetails>(`${groupPrefixDays}/${boxID}`, {
			method: 'GET',
		})
		return clientPackageDetailsModel(data)
	},
}
